import { Box, IconButton, TextField, Tooltip } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyledInputLabel } from '../../../../../components/inputs/InputLabel';
import { StyledQuestionMark } from '../../../../../components/QuestionMark';

type AgreementNameFieldProps = {
  value: string;
  disabled?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const AgreementNameField = ({
  value,
  disabled = false,
  onChange,
}: AgreementNameFieldProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <StyledInputLabel htmlFor="name">
          Agreement name <span aria-hidden="true">*</span>
        </StyledInputLabel>
        <Tooltip title={t('agreements.tooltips.name')} placement="top">
          <IconButton size="small" sx={{ marginLeft: '3px' }}>
            <StyledQuestionMark fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
      <TextField
        id="name"
        name="name"
        placeholder="Agreement name"
        required
        type="text"
        fullWidth
        sx={{
          width: '100%',
        }}
        onChange={onChange}
        value={value}
        inputProps={{ maxLength: 150 }}
        disabled={disabled}
      />
    </>
  );
};
